import { Component, Input } from '@angular/core';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { ImageInfo } from './upload/upload.component';

@Component({
   selector: 'samweb-upload-image-dialog',
   templateUrl: './upload-image-dialog.component.html',
   styleUrls: ['./upload-image-dialog.component.scss'],
})
export class UploadImageDialogComponent {
   @Input() public editor: EditorComponent;

   public opened = false;
   public src: string;
   public height: number;
   public width: number;

   public get canInsert(): boolean {
      return !this.src;
   }

   public uploadImage(): void {
      // Invoking the insertImage command of the Editor.
      this.editor.exec('insertImage', this.imageInfo);

      // Closing the Dialog.
      this.close();
   }

   public get imageInfo(): ImageInfo {
      return {
         src: this.src,
         height: this.height,
         width: this.width,
      };
   }

   public setImageInfo(value: ImageInfo) {
      if (value) {
         this.src = value.src;
         this.height = value.height;
         this.width = value.width;
      } else {
         this.resetData();
      }
   }

   public open(): void {
      this.opened = true;
   }

   public close(): void {
      this.opened = false;
      this.resetData();
   }

   public resetData(): void {
      this.src = null;
      this.width = null;
      this.height = null;
   }
}
